import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFarmWeatherLocation from '../_reducers/farmWeatherLocation';

export const selectFarmWeatherLocationState =
  createFeatureSelector<fromFarmWeatherLocation.FarmWeatherLocationState>('farmWeatherLocations');

export const selectAllFarmWeatherLocations = createSelector(
  selectFarmWeatherLocationState,
  fromFarmWeatherLocation.selectAll
);

export const selectFarmWeatherLocationEntities = createSelector(
  selectFarmWeatherLocationState,
  fromFarmWeatherLocation.selectEntities
);

export const selectFarmWeatherLocationById = (id: number) =>
  createSelector(selectFarmWeatherLocationEntities, (entities) => entities[id]);

export const selectFarmWeatherLocationTotal = createSelector(
  selectFarmWeatherLocationState,
  fromFarmWeatherLocation.selectTotal
);
